import { useMemo } from 'react';
import type { CountryCode } from 'libphonenumber-js';

/** Ukraine only — no env, no IP detection. */
export const useAllowedCountries = (): {
  countries: CountryCode[];
  finalDefaultCountry: CountryCode;
  isSingleCountry: true;
} =>
  useMemo(
    () => ({
      countries: ['UA'],
      finalDefaultCountry: 'UA',
      isSingleCountry: true,
    }),
    [],
  );
